export const _htmlMimeTypes = [
  "text/html",
  'text/html; version="2.0"',
  'text/html; version="3.2"',
  'text/html; version="4.0"',
  'text/html; version="4.01"',
  'text/html; version="5"',
];
